import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGraphIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 14.25,
			width: 2.5,
			height: 6.75,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 18,
			y: 14.25,
			width: 2.5,
			height: 6.75,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 3,
			width: 2.5,
			height: 18,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 13,
			y: 8.625,
			width: 2.5,
			height: 12.375,
			fill: "currentColor"
		})
	]
});
export default SvgGraphIcon;
